import React from 'react'
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';



const FaqSection = (props) => {
    const [expanded, setExpanded] = React.useState(false);

    const handleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };


    return (
        <div className="wpo-benefits-section">
            <div className="row">
                <div className="col-lg-12 col-12">
                    <div className="wpo-benefits-item">
                        <Accordion expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
                            <AccordionSummary
                                aria-controls="panel1bh-content"
                                id="panel1bh-header"
                            >
                                <Typography>How do I register for a course or event?</Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Typography>
                                   You can register by visiting our Courses or Events page, selecting your preferred program, and clicking the "Book Now" or "Enroll Now" button. Fill in your details, complete the payment, and you'll receive a confirmation email with all the necessary information.
                                </Typography>
                            </AccordionDetails>
                        </Accordion>
                        <Accordion expanded={expanded === 'panel2'} onChange={handleChange('panel2')}>
                            <AccordionSummary
                                aria-controls="panel2bh-content"
                                id="panel2bh-header"
                            >
                                <Typography>Will I receive a certificate after completing the course?</Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Typography>
                                    Yes! Upon successful completion of any training program, you will receive a professional certificate from Marsh Events & Training Hub. You can also verify your certificate online using our Verification page with your reference number and passport details.
                                </Typography>
                            </AccordionDetails>
                        </Accordion>
                        <Accordion expanded={expanded === 'panel3'} onChange={handleChange('panel3')}>
                            <AccordionSummary
                                aria-controls="panel3bh-content"
                                id="panel3bh-header"
                            >
                                <Typography>What is your cancellation and refund policy?</Typography>
                
                            </AccordionSummary>
                            <AccordionDetails>
                                <Typography>
                                    Cancellations made 30+ days before the course start date receive a full refund minus admin fees. Cancellations 15-29 days before receive 50% refund. Cancellations less than 15 days before are non-refundable. If we cancel the course, you'll get a full refund or transfer option.
                                </Typography>
                            </AccordionDetails>
                        </Accordion>
                        <Accordion expanded={expanded === 'panel4'} onChange={handleChange('panel4')}>
                            <AccordionSummary
                                aria-controls="panel4bh-content"
                                id="panel4bh-header"
                            >
                                <Typography>Are your courses available online or only in-person?</Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Typography>
                                    We offer both online and in-person training programs across various global locations. Each course page clearly indicates the delivery format. Our events are typically held in major cities worldwide including Netherlands, UK, UAE, and more. Check the specific course details for location and format information.
                                </Typography>
                            </AccordionDetails>
                        </Accordion>
                    </div>
                </div>
            </div>
        </div>

    )
}

export default FaqSection;